import { Injectable, Inject, EnvironmentInjector } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpRequestService } from './http-service.service';
import { LocalStorageService } from './local-storage.service';

@Injectable({
    providedIn: 'root'
  })
  export class FundsPortalService extends HttpRequestService<any>{
    
    constructor(
        httpClient: HttpClient,
        private localStorageService: LocalStorageService) {
        super(httpClient);
      }
  

    public postCompanyUser(body: {}){
        const httpHeaders: HttpHeaders = new HttpHeaders()
        
        return this.post(`client_user`, body, undefined, httpHeaders)
              .pipe(
              map((data: any) => data),
              catchError(this.handleError));
    }

    public postAddMobileNo(body: {}){
        const httpHeaders: HttpHeaders = new HttpHeaders()
        
        return this.post(`add_mobile_number`, body, undefined, httpHeaders)
          .pipe(
              map((data: any) => data),
              catchError(this.handleError));
    }

    public postValidateMobileNo(body: {}) {
        const httpHeaders: HttpHeaders = new HttpHeaders()
        
        return this.post(`verify_mobile_no`, body, undefined, httpHeaders)
          .pipe(
              map((data: any) => data),
              catchError(this.handleError));
    }

    public validateInviteCode(body: {}) {
        const httpHeaders: HttpHeaders = new HttpHeaders()
        
        return this.post(`validate_invite_code`, body, undefined, httpHeaders)
          .pipe(
              map((data: any) => data),
              catchError(this.handleError));
    }

    public postVerifyEmailOtp(body: {}) {
        const bearer = this.localStorageService.get('bearer');
        const httpHeaders: HttpHeaders = bearer
          ? new HttpHeaders().set('Authorization', `Bearer ${bearer}`)
          : new HttpHeaders();

        return this.post(`verify_email_otp`, body, undefined, httpHeaders)
          .pipe(
              map((data: any) => data),
              catchError(this.handleError));
    }

    public postInitiateMfaSetup(body: {}) {
        const bearer = this.localStorageService.get('bearer');
        const httpHeaders: HttpHeaders = bearer
          ? new HttpHeaders().set('Authorization', `Bearer ${bearer}`)
          : new HttpHeaders();

        return this.post(`mfa/software/setup`, body, undefined, httpHeaders)
          .pipe(
              map((data: any) => data),
              catchError(this.handleError));
    }

    public postCompleteMfaSetup(body: {}) {
        const bearer = this.localStorageService.get('bearer');
        const httpHeaders: HttpHeaders = bearer
          ? new HttpHeaders().set('Authorization', `Bearer ${bearer}`)
          : new HttpHeaders();

        return this.post(`mfa/software/verify_setup`, body, undefined, httpHeaders)
          .pipe(
              map((data: any) => data),
              catchError(this.handleError));
    }

    public postVerifyMfa(body: {}) {
        const bearer = this.localStorageService.get('bearer');
        const httpHeaders: HttpHeaders = bearer
          ? new HttpHeaders().set('Authorization', `Bearer ${bearer}`)
          : new HttpHeaders();

        return this.post(`login_verification_mfa`, body, undefined, httpHeaders)
          .pipe(
              map((data: any) => data),
              catchError(this.handleError));
    }

          public postValidateSoftwareMfaOtp(body: {}) {
            const httpHeaders: HttpHeaders = new HttpHeaders();

            return this.post(`mfa/software/validate_otp`, body, undefined, httpHeaders)
              .pipe(
                map((data: any) => data),
                catchError(this.handleError));
          }

    public postResendOtp(body: {}){
        const httpHeaders: HttpHeaders = new HttpHeaders()
        
        return this.post(`resend_mobile_verification_otp`, body, undefined, httpHeaders)
          .pipe(
              map((data: any) => data),
              catchError(this.handleError));
    }

    public postUploadDocument(body: {}) {
      const httpHeaders: HttpHeaders = new HttpHeaders()
      .set('Authorization', `Bearer ${this.localStorageService.get('bearer') || ''}`);
      
      return this.post(`upload_document`, body, undefined, httpHeaders)
        .pipe(
            map((data: any) => data),
            catchError(this.handleError));
    }

    public postEmailDocument(body: {}) {
      const httpHeaders: HttpHeaders = new HttpHeaders()
      .set('Authorization', `Bearer ${this.localStorageService.get('bearer') || ''}`);

      return this.post(`email_documents`, body, undefined, httpHeaders)
        .pipe(
            map((data: any) => data),
            catchError(this.handleError));
    }

    public getDocuments(body: {}) {
      const httpHeaders: HttpHeaders = new HttpHeaders()
      .set('Authorization', `Bearer ${this.localStorageService.get('bearer') || ''}`);

      return this.get(`get_documents`,undefined, body, httpHeaders)
        .pipe(
            map((data: any) => data),
            catchError(this.handleError));
    }

    public postRefreshToken() {
      const httpHeaders: HttpHeaders = new HttpHeaders()
      .set('Authorization', `Bearer ${this.localStorageService.get('bearer') || ''}`);

      return this.post(`refresh_token`, undefined, undefined, httpHeaders)
        .pipe(
            map((data: any) => data),
            catchError(this.handleError));
  }
    

    public postForgotPassword(body: {}){
        const httpHeaders: HttpHeaders = new HttpHeaders()
        
        return this.post(`forgot_password`, body, undefined, httpHeaders)
          .pipe(
              map((data: any) => data),
              catchError(this.handleError));
    }

    public postForgotPasswordStart(body: {}){
        const httpHeaders: HttpHeaders = new HttpHeaders();

        return this.post(`forgot_password/start`, body, undefined, httpHeaders)
          .pipe(
              map((data: any) => data),
              catchError(this.handleError));
    }

    public postForgotPasswordVerifyMfa(body: {}){
        const httpHeaders: HttpHeaders = new HttpHeaders();

        return this.post(`forgot_password/verify_mfa`, body, undefined, httpHeaders)
          .pipe(
              map((data: any) => data),
              catchError(this.handleError));
    }

    public postForgotPasswordVerify(body: {}){
        const httpHeaders: HttpHeaders = new HttpHeaders();

        return this.post(`forgot_password/verify`, body, undefined, httpHeaders)
          .pipe(
              map((data: any) => data),
              catchError(this.handleError));
    }

    public postForgotPasswordVerifyChallenge(body: {}){
        const httpHeaders: HttpHeaders = new HttpHeaders();

        return this.post(`forgot_password/verify_challenge`, body, undefined, httpHeaders)
          .pipe(
              map((data: any) => data),
              catchError(this.handleError));
    }

    public postValidateForgotPassword(body: {}){
        const httpHeaders: HttpHeaders = new HttpHeaders()
        
        return this.post(`/validate_forgot_password_code`, body, undefined, httpHeaders)
          .pipe(
              map((data: any) => data),
              catchError(this.handleError));
    }

    public postChangePassword(body: {}){
        const httpHeaders: HttpHeaders = new HttpHeaders()
          .set('Authorization', `Bearer ${this.localStorageService.get('bearer') || ''}`);
        
        return this.post(`change_ps`, body, undefined, httpHeaders)
          .pipe(
              map((data: any) => data),
              catchError(this.handleError));
    }    

    private handleError(error: HttpErrorResponse) {
        if (error.status === 0) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.error);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong.
          console.error(
            `Backend returned code ${error.status}, body was: `, error.error);
        }
        // Return an observable with a user-facing error message.
        return throwError(() => error.error);
    }
}